import React from 'react';

import { Info } from 'lucide-react';

interface SectionTooltipProps {
    content: string;
};

export const SectionTooltip = ({ content }: SectionTooltipProps) => {
    if (!content) return null;

    return (
        <div className="mbts_analysis_v2__tooltip">
            <Info className="mbts_analysis_v2__tooltip__btn" />
            <div
                className="mbts_analysis_v2__tooltip__content"
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </div>
    );
};
